import React from "react";
import { HelpCircle, LifeBuoy, Mail } from "lucide-react";
import { Link } from "react-router-dom";

// Import Brazilian detector and mappings
import { getBrazilianStatus } from '../../utils/detectBrazil';
import { helpSupportPtBR } from '../../components/mappings/helpSupport.pt-br';

const HelpSupport = () => {
  // Check if user is Brazilian
  const isBrazilian = getBrazilianStatus();
  
  // Simple translation function
  const t = (text) => {
    if (!isBrazilian) return text;
    return helpSupportPtBR[text] || text;
  };
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-900 via-slate-900 to-emerald-900 flex flex-col items-center justify-center p-6">
      <div className="text-center max-w-2xl mx-auto">
        {/* Icons */}
        <div className="flex items-center justify-center gap-4 mb-6">
          <LifeBuoy className="w-12 h-12 text-emerald-300" />
          <HelpCircle className="w-12 h-12 text-emerald-300" />
        </div>

        {/* Title */}
        <h1 className="text-5xl font-extrabold text-white mb-4">
          {t("Help & Support")}
        </h1>

        {/* Description */}
        <p className="text-slate-300 text-lg mb-8">
          {t("Need help? Check out our FAQ section or reach out to our support team directly.")}
          {" "}
          {t("We're here to assist you with any questions you might have.")}
        </p>

        {/* Support Options */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          {/* Email Support Button */}
          <a
            href="mailto:support@pickstarai.com"
            className="inline-flex items-center px-6 py-3 bg-emerald-600 hover:bg-emerald-500 text-white font-semibold rounded-lg shadow-md transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:ring-offset-2"
            aria-label="Email Support"
          >
            <Mail className="w-5 h-5 mr-2" />
            {t("Email Support")}
          </a>

          {/* FAQ Button */}
          <Link
            to="/faq"
            className="inline-flex items-center px-6 py-3 bg-emerald-600/20 hover:bg-emerald-600/30 text-emerald-300 font-semibold rounded-lg shadow-md transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-emerald-400/50 focus:ring-offset-2"
          >
            <HelpCircle className="w-5 h-5 mr-2" />
            {t("View FAQ")}
          </Link>
        </div>

        {/* Additional Information */}
        <div className="mt-6">
          <p className="text-slate-400 text-sm">
            {t("Our support team typically responds within 14 business days. We prioritize Pro responses.")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default HelpSupport;
